export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "wettnet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "wettnet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
